import React, { FC } from "react";
import { FormControl, InputLabel, ListSubheader, MenuItem, Select, SelectChangeEvent, } from "@mui/material";
import { InputSelectProperties } from "../InputSelect";
import { Regiao } from "../InputSelectRegioes";
import { CollectionUtil } from "src/framework/commons/CollectionUtil";

export interface InputSelectRegiaoProperties extends InputSelectProperties {
  list: Regiao[];
  allowNull?: boolean;
  value: number | null;
  onChange(value: number | null): void;
}

const InputSelectRegiao: FC<InputSelectRegiaoProperties> = (props: InputSelectRegiaoProperties) => {
  const renderOptions = (): React.ReactNode[] => {
    const options: React.ReactNode[] = [];

    if (props.allowNull) {
      options.push(
        <MenuItem value={""}>
          <em>Nenhum</em>
        </MenuItem>
      );
    }

    const listCustom = (props.list || []).sort(CollectionUtil.singleSort("grupo"));
    let grupoAnt: any = null;

    listCustom.forEach((rec: Regiao) => {
      if (grupoAnt === null || grupoAnt !== rec.grupo) {
        options.push(<ListSubheader key={`grupo-regiao-${rec.grupo}`}>{rec.grupo}</ListSubheader>);
        options.push(<MenuItem key={`value-regiao-${rec.id}`} value={rec.id}>{rec.nome}</MenuItem>);
        grupoAnt = rec.grupo;
      } else {
        options.push(<MenuItem key={`value-regiao-${rec.id}`} value={rec.id}>{rec.nome}</MenuItem>);
      }
    });

    return options;
  }

  const handleChange = (event: SelectChangeEvent<number>): void => {
    let value: any = (event.target.value || null);

    if (value === "") {
      value = null;
    }

    props.onChange(value);
  };

  return (
    <FormControl
      fullWidth={true}
      variant="outlined"
      size={"small"}
      margin={props.margin}
    >
      <InputLabel htmlFor="grouped-select">{props.label}</InputLabel>
      <Select
        style={{
          textAlign: "left",
          padding: "0px",
          margin: "0px 0px -3px 0px",
        }}
        margin="dense"
        id={props.id}
        value={(props.value || "")} 
        onChange={handleChange}
      >
        {renderOptions()}
      </Select>
    </FormControl>
  );
}

export { InputSelectRegiao };